module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-96x96-f2f32c043010f76bc7f7ab1346097edd.png";